export interface EndorsementsState {
  isLoading: boolean | null;
};
export const initialState = {
  isLoading: null
};